import instance from "@/services/apiService";
import apiUrls from "@/services/apiUrls";
import { initialPaymentMethod } from "@/common/helpers/PaymentHelper";
import store from "@/store";

const state = {
  paymentMethods: [], // consist of optional pay at store, and optional payment gateway(s). wess-legacy make sure at least has 1 payment method.
  gatewayPaymentMethods: [], // store optional payment gateway(s)
  paymentMethod: null,
};

const getters = {
  paymentMethods: (state) => state.paymentMethods,
  gatewayPaymentMethods: (state) => state.gatewayPaymentMethods,
  paymentMethod: (state) => state.paymentMethod,
};

const actions = {
  async getPaymentMethods({ commit }) {
    try {
      const response = await instance.get(
        `${apiUrls.PAYMENT_METHOD}?branch=${store.getters.selectedBranch.id}&published=1`
      );
      // Extract CWA payment method
      const payload = response.data.filter(
        (data) => data.gateway?.isCwaPaymentMethod
      );

      commit("updatePaymentMethodsCount", payload)
      commit("getPaymentMethods", payload);
    } catch (error) {
      console.log(error);
    }
  },
};

const mutations = {
  getPaymentMethods: (state, payload) => {
    // Check if pay at store is allowed
    if (store.getters.init.allowPayAtStore) {
      state.paymentMethods = [initialPaymentMethod, ...payload];
    } else {
      state.paymentMethods = payload;
    }

    // Set default selected payment method
    if (state.paymentMethods.length) {
      state.paymentMethod = state.paymentMethods[0];
    }
  },
  updatePaymentMethodsCount(state, payload) {
    state.gatewayPaymentMethods = payload;
  },
  setPaymentMethod: (state, payload) => (state.paymentMethod = payload),
};

export default {
  state,
  getters,
  actions,
  mutations,
};
